import { CheckCircle, Copy } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import React from "react";
import { OrganizationWithSecret } from "../../models/Organization";

interface OrganizationCreatedModalProps {
  open: boolean;
  onClose: () => void;
  organization: OrganizationWithSecret | null;
  onGoToOrganization: () => void;
}

const OrganizationCreatedModal: React.FC<OrganizationCreatedModalProps> = ({
  open,
  onClose,
  organization,
  onGoToOrganization,
}) => {
  const handleClose = () => onClose();

  const handleCopyToClipboard = () => {
    if (organization)
      navigator.clipboard.writeText(organization.organizationSecret);
  };

  const handleGoToOrganization = () => {
    onGoToOrganization();
    onClose();
  };

  if (!organization)
    return null;

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => !isOpen && handleClose()}
    >
      <DialogContent className="min-w-[30%] flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle className="size-5" />
            Organization Created!
          </DialogTitle>
        </DialogHeader>
        <Separator />

        <div className="flex flex-col">
          <span className="h-9 flex items-center text-sm">
            <strong>ID:</strong>&nbsp;{organization.id}
          </span>
          <span className="h-9 flex items-center text-sm">
            <strong>Name:</strong>&nbsp;{organization.name}
          </span>
          <span className="h-9 flex items-center text-sm">
            <strong>Intact ID:</strong>&nbsp;{organization.intactId}
          </span>
          <div className="flex items-center gap-2">
            <span className="flex-grow text-sm">
              <strong>Secret:</strong> {organization.organizationSecret}
            </span>
            <Button variant="ghost" size="icon-sm" onClick={handleCopyToClipboard}>
              <Copy className="size-4" />
            </Button>
          </div>
        </div>

        <Separator />
        <DialogFooter>
          <Button
            variant="secondary"
            onClick={handleClose}
            className="w-20"
          >
            Cancel
          </Button>
          <Button
            onClick={handleGoToOrganization}
            className="w-20"
          >
            Go to
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default OrganizationCreatedModal;
